import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const API_URL = `${API_BASE_PATH}/register/emp/filter`;

export interface Employee {
  employee_id: string;
  firstname: string;
  lastname: string;
  username: string;
  role_name: string;
  department_name: string;
  designation_name: string;
}

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

const useGetEmployees = (token?: string | null) => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEmployees = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const authToken = token || localStorage.getItem("authToken");

      const response = await axios.get(API_URL, {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
          accept: "application/json",
        },
      });

      // Normalize data to match Employee interface
      const employeeArray: Employee[] = Array.isArray(response.data)
        ? response.data.map((emp: any) => ({
            employee_id: emp.employee_id,
            firstname: emp.firstname,
            lastname: emp.lastname,
            username: emp.username,
            role_name: emp.role || "",
            department_name: emp.department || "",
            designation_name: emp.designation || "",
          }))
        : [];

      setEmployees(employeeArray);
    } catch (err: any) {
      const message = extractErrorMessage(err);
      setError(message);
      toast.error(message);
      setEmployees([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, [token]);

  return {
    employees,
    isLoading,
    error,
    refetch: fetchEmployees,
  };
};

export default useGetEmployees;
